<template>
  <div class="page-filter-bar-test-C">
    <r-flex class="r-mb-16">
      <h3>FilterBar Test Sayfası</h3>
    </r-flex>

    <filter-bar
      ref="filterBarRef"
      :show-first-row="true"
      :show-filter-button="false"
      filter-button-text="Filtre"
      :is-loading="isLoading"
      :show-dynamic-properties="true"
      :initial-property-values="initialPropertyValues"
      @filter="onFilter"
      @property-change="onPropertyChange"
    >
      <!-- 1. Satır: Soru Çeşidi + Branş -->
      <template #first-row>
        <r-select
          v-model="questPart"
          label="Soru Çeşidi"
          :data="questParts"
          txt="txt"
          val="val"
          width="18%"
          @change="onQuestPartChange"
        />
        <r-select
          v-model="branchId"
          label="Branş"
          :data="branchList?.data || []"
          txt="title"
          val="id"
          width="22%"
          style="color: rgb(17, 17, 17)"
        />
      </template>

      <!-- 2. Satır: Kitap Türü + Kitap (Çoklu Seçim) -->
      <template #second-row>
        <r-select
          v-model="noteCategoryId"
          label="Kitap Türü"
          :data="notesCatsList?.data || []"
          txt="title"
          val="id"
          width="20%"
          @change="onNoteCategoryChange"
          style="color: rgb(17, 17, 17)"
        />
        <r-select
          label="Kitap"
          :data="noteList?.data || noteList?.Data || []"
          txt="name"
          val="id"
          :selectable="true"
          v-model:selected="noteIds"
          width="24%"
          style="color: rgb(17, 17, 17)"
        />
      </template>

      <!-- Sağ taraftaki aksiyon buton slotu -->
      <template #actions>
        <r-btn
          bgcolor="#1e88e5"
          class="r-ml-8"
          @click="triggerFilter"
          :disabled="isLoading"
        >
          Filtre
        </r-btn>
        <r-btn
          bgcolor="#aa6600"
          class="r-ml-8"
          @click="resetFilters"
          :disabled="isLoading"
        >
          Filtreleri Temizle
        </r-btn>
        <r-btn
          bgcolor="#6a1b9a"
          class="r-ml-8"
          @click="resetDynamicSelections"
          :disabled="isLoading"
        >
          Dinamik Filtreleri Resetle
        </r-btn>
      </template>
    </filter-bar>

    <!-- Son gönderilen filtre payload'u -->
    <div class="filter-debug-panel-C">
      <h4>Son Gönderilen Filtre Parametreleri</h4>
      <pre>{{ JSON.stringify(lastFilterPayload, null, 2) }}</pre>
    </div>
    <div class="filter-debug-panel-C">
      <h4>Son Property Değişimi</h4>
      <pre>{{ JSON.stringify(lastPropertyChange, null, 2) }}</pre>
    </div>
  </div>
</template>

<script>
import { ref, onMounted } from "vue";
import { useStore } from "vuex";
import FilterBar from "@/components/FilterBar/FilterBar.vue";

export default {
  name: "PageFilterBarTest",
  components: {
    FilterBar
  },
  setup() {
    const store = useStore();
    const isLoading = ref(false);

    const filterBarRef = ref(null);

    // Gerçek filtre alanları
    const questPart = ref(1);
    const questParts = ref([
      { txt: "Temel Bilimler", val: 1 },
      { txt: "Klinik Bilimler", val: 2 }
    ]);
    const branchId = ref(null);
    const branchList = ref({ data: [] });

    const notesCatsList = ref({ data: [] });
    const noteCategoryId = ref(null);
    const noteList = ref({ data: [] });
    // Çoklu kitap seçimi için dizi
    const noteIds = ref([]);

    const initialPropertyValues = ref({});

    const lastFilterPayload = ref(null);
    const lastPropertyChange = ref(null);

    const onFilter = payload => {
      // FilterBar içinden gelen dinamik property seçimleri + gerçek filtre alanları
      lastFilterPayload.value = {
        questPart: questPart.value,
        branchId: branchId.value,
        noteCategoryId: noteCategoryId.value,
        noteIds: noteIds.value,
        // FilterBar'dan gelen obje (propertyValues: { [propDef.id]: number[] })
        ...payload
      };
    };

    const onPropertyChange = payload => {
      // { propertyDefinitionId, selectedValues }
      lastPropertyChange.value = payload;
    };

    const resetFilters = () => {
      questPart.value = 1;
      branchId.value = null;
      noteCategoryId.value = null;
      noteIds.value = [];
      lastFilterPayload.value = null;
      lastPropertyChange.value = null;
    };

    const resetDynamicSelections = () => {
      if (
        filterBarRef.value &&
        typeof filterBarRef.value.resetDynamicProperties === "function"
      ) {
        filterBarRef.value.resetDynamicProperties();
      }
    };

    const triggerFilter = () => {
      // FilterBar'ın kendi Filtre butonu dışında, dışarıdan manuel tetikleme
      if (
        filterBarRef.value &&
        typeof filterBarRef.value.handleFilter === "function"
      ) {
        filterBarRef.value.handleFilter();
      }
    };

    const getCatList = async (pid = 0) => {
      const list = await store.dispatch("getDatas", {
        api: "categories/getsubcategories",
        params: { pid }
      });
      return list;
    };

    const getNoteCatsList = async () => {
      const list = await store.dispatch("getDatas", {
        api: "notes/getnotecategories"
      });
      return list;
    };

    const getNotesByCategory = async (categoryId, notCategoryId) => {
      const list = await store.dispatch("getDatas", {
        api: "notes/getnotesbycategoryandnotcatid",
        params: {
          categoryId: categoryId,
          isActive: true,
          notCategoryId: notCategoryId
        }
      });
      return list;
    };

    const onQuestPartChange = async e => {
      if (!e || e.val === undefined) return;
      questPart.value = e.val;

      // Tüm alt kategorileri al (pid=0)
      const result = await getCatList(0);
      if (result && result.data && Array.isArray(result.data)) {
        const filteredData = result.data.filter(item => {
          const parentId =
            item.parentId !== undefined ? item.parentId : item.ParentId;
          if (e.val === 1) {
            return parentId === 1;
          } else if (e.val === 2) {
            return parentId === 2;
          }
          return false;
        });
        branchList.value = { data: filteredData };
        branchId.value = filteredData.length > 0 ? filteredData[0].id : null;
      } else {
        branchList.value = { data: [] };
        branchId.value = null;
      }
    };

    const onNoteCategoryChange = async e => {
      if (!e || e.id === undefined) return;
      noteCategoryId.value = e.id;

      if (branchId.value && noteCategoryId.value) {
        const result = await getNotesByCategory(
          branchId.value,
          noteCategoryId.value
        );
        const dataArray =
          result?.data || result?.Data || (Array.isArray(result) ? result : []);
        if (dataArray && Array.isArray(dataArray) && dataArray.length > 0) {
          noteList.value = { data: dataArray };
          // Varsayılan olarak ilk kitabı seçili yap (çoklu seçimde dizi olarak)
          const firstId = dataArray[0].id || null;
          noteIds.value = firstId !== null ? [firstId] : [];
        } else {
          noteList.value = { data: [] };
          noteIds.value = [];
        }
      } else {
        noteList.value = { data: [] };
        noteIds.value = [];
      }
    };

    onMounted(async () => {
      // Kitap türlerini yükle
      const noteCats = await getNoteCatsList();
      notesCatsList.value = noteCats || { data: [] };

      // İlk açılışta questPart=1 için branş listesini hazırla
      const branchResult = await getCatList(0);
      if (
        branchResult &&
        branchResult.data &&
        Array.isArray(branchResult.data)
      ) {
        const filteredData = branchResult.data.filter(item => {
          const parentId =
            item.parentId !== undefined ? item.parentId : item.ParentId;
          // initial questPart: 1 (Temel)
          return parentId === 1;
        });
        branchList.value = { data: filteredData };
        branchId.value = filteredData.length > 0 ? filteredData[0].id : null;
      }
    });

    return {
      store,
      isLoading,
      filterBarRef,
      questPart,
      questParts,
      branchId,
      branchList,
      notesCatsList,
      noteCategoryId,
      noteList,
      noteIds,
      initialPropertyValues,
      lastFilterPayload,
      lastPropertyChange,
      onFilter,
      onPropertyChange,
      resetFilters,
      resetDynamicSelections,
      triggerFilter,
      onQuestPartChange,
      onNoteCategoryChange
    };
  }
};
</script>

<style scoped>
.page-filter-bar-test-C {
  width: 100%;
  padding: 16px;
}

.filter-debug-panel-C {
  margin-top: 16px;
  padding: 12px;
  background: #f5f5f5;
  border-radius: 4px;
  font-size: 12px;
}
</style>
